'use strict';

/**
 * Do not edit directly, this file was auto-generated.
 */

var mobile = {
  "theme": "mobile",
  "radius": {
    "backgroundMedium": "8px",
    "backgroundXsmall": "3px",
    "backgroundRounded": "300px",
    "backgroundSmall": "4px",
    "backgroundLarge": "16px",
    "backgroundXlarge": "32px",
    "surfaceMedium": "8px",
    "surfaceSmall": "4px",
    "surfaceLarge": "16px",
    "surfaceXlarge": "32px"
  },
  "borderWeight": {
    "xsmall": "1px",
    "small": "1.5px",
    "medium": "2px"
  },
  "size": {
    "heightSmall": "34px",
    "heightMedium": "44px",
    "heightLarge": "52px",
    "heightXxxsmall": "18px",
    "heightXlarge": "56px",
    "heightXxsmall": "20px",
    "heightXsmall": "24px",
    "widthSmall": "34px",
    "widthMedium": "44px",
    "widthLarge": "52px",
    "widthXxxsmall": "18px",
    "widthXxsmall": "20px",
    "widthXsmall": "24px"
  },
  "space": {
    "paddingDynamicXxsmall": "4px",
    "paddingDynamicXsmall": "8px",
    "paddingDynamicMedium": "16px",
    "paddingDynamicSmall": "16px",
    "paddingDynamicLarge": "24px",
    "paddingDynamicXlarge": "24px",
    "paddingStaticSmall": "16px",
    "paddingStaticXsmall": "8px",
    "paddingStaticXxsmall": "4px",
    "paddingStaticMedium": "24px",
    "paddingStaticLarge": "32px",
    "paddingStaticXlarge": "40px",
    "paddingStaticXxlarge": "48px",
    "gapMedium": "8px",
    "gapSmall": "4px",
    "gapXsmall": "4px",
    "gapInternal": "16px",
    "gapSection": "24px",
    "gapPage": "32px",
    "gapFooter": "64px"
  },
  "iconButton": {
    "borderRadius": "8px",
    "borderWeight": "1px",
    "widthSmall": "34px",
    "heightSmall": "34px",
    "widthMedium": "44px",
    "heightMedium": "44px",
    "widthLarge": "52px",
    "heightLarge": "52px"
  },
  "button": {
    "borderRadius": "8px",
    "borderWeight": "1px",
    "heightSmall": "34px",
    "heightMedium": "44px",
    "heightLarge": "52px",
    "paddingLeftRight": "16px",
    "paddingTopBottom": "8px",
    "gap": "8px"
  },
  "box": {
    "borderRadius": "8px",
    "borderWeight": "1px",
    "paddingXsmall": "4px",
    "paddingSmall": "8px",
    "paddingLarge": "16px"
  },
  "checkbox": {
    "borderRadius": "3px",
    "borderWeight": "1.5px",
    "width": "18px",
    "height": "18px",
    "gap": "4px"
  },
  "input": {
    "borderRadius": "8px",
    "borderWeight": "1px",
    "height": "56px",
    "gap": "16px",
    "paddingLeftRight": "16px"
  },
  "search": {
    "borderRadius": "8px",
    "borderWeight": "1px",
    "heightMedium": "44px",
    "heightLarge": "52px",
    "gap": "8px",
    "paddingLeftRight": "16px"
  },
  "radio": {
    "borderRadius": "300px",
    "borderWeight": "1.5px",
    "width": "20px",
    "height": "20px",
    "gap": "4px"
  },
  "actionTile": {
    "paddingTop": "16px",
    "borderRadius": "8px",
    "paddingRight": "8px",
    "paddingLeft": "8px",
    "paddingBottom": "16px"
  },
  "accordion": {
    "borderRadius": "8px"
  },
  "status": {
    "radius": "4px",
    "heightLarge": "52px",
    "heightSmall": "34px",
    "heightMedium": "44px",
    "paddingSmall": "8px",
    "paddingMedium": "16px",
    "paddingLarge": "16px",
    "gap": "8px"
  },
  "link": {
    "gap": "4px"
  },
  "effect": {
    "stateFocusedStroke": "2px",
    "elevationOverlayX": "0px",
    "elevationOverlayY": "4px",
    "elevationOverlayBlur": "16px",
    "elevationOverlaySpread": "0px",
    "elevationOverlayOpacity": "16px",
    "elevationOverflowX": "0px",
    "elevationOverflowY": "-2px",
    "elevationOverflowBlur": "8px",
    "elevationOverflowSpread": "0px",
    "elevationOverflowOpacity": "16px",
    "elevationRaisedX": "0px",
    "elevationRaisedY": "2px",
    "elevationRaisedBlur": "6px",
    "elevationRaisedSpread": "0px",
    "elevationRaisedOpacity": "16px"
  },
  "type": {
    "familyDecorative": "Mulish",
    "familyBase": "Mulish"
  },
  "textSize": {
    "h1": "28px",
    "h2": "24px",
    "h3": "20px",
    "h4": "19px",
    "h5": "17px",
    "body": "16px",
    "callout": "15px",
    "footnote": "13px",
    "caption": "12px",
    "subcaption": "11px",
    "smallest": "9px"
  },
  "weight": {
    "regular": "400",
    "medium": "500",
    "bold": "700",
    "semibold": "600"
  },
  "letterSpacing": {
    "caption": "0px",
    "h1": "-0.4px",
    "h2": "-0.4px",
    "h3": "-0.4px",
    "h4": "-0.4px",
    "h5": "-0.4px",
    "body": "-0.2px",
    "callout": "-0.2px",
    "footnote": "-0.1px",
    "subcaption": "0.1px",
    "smallest": "0.1px"
  },
  "lineHeight": {
    "h1": "40px",
    "h2": "32px",
    "h3": "32px",
    "h4": "24px",
    "h5": "24px",
    "body": "24px",
    "footnote": "20px",
    "callout": "20px",
    "caption": "16px",
    "subcaption": "16px",
    "smallest": "18px"
  }
};

exports.mobile = mobile;
//# sourceMappingURL=mobile.cjs.map
